import { render, staticRenderFns } from "./ToolbarColorButton.vue?vue&type=template&id=30475665&"
import script from "./ToolbarColorButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ToolbarColorButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports